module.exports = __webpack_public_path__ + "static/media/chevron-right.8beae9a6.svg";